import { cn } from "@/lib/utils";

const sizes = {
  sm: "h-8 w-8",
  md: "h-10 w-10",
  lg: "h-16 w-16",
} as const;

type AppLogoProps = {
  size?: keyof typeof sizes;
  className?: string;
};

/** Logo Pointo — bleu #051941 sur fond blanc (backoffice uniquement) */
export function AppLogo({ size = "md", className }: AppLogoProps) {
  return (
    <img
      src="/pointo-logo.png"
      alt="Pointo"
      className={cn(
        "shrink-0 rounded-2xl object-cover shadow-sm",
        sizes[size],
        className
      )}
    />
  );
}
